import React from 'react';
import styled from 'styled-components';
import { colors } from '../../DesignSystem/colors';
import { Breakpoints } from '../../DesignSystem/design-system';
import { TYPOGRAPHY } from '../../DesignSystem/typography';
const getTypography = (typographyName, device) => {
    const style = TYPOGRAPHY[typographyName];
    return style[device];
};
const ImpP = styled.p `
  margin: 0;
  padding: 0;
  font-style: normal;
  font-feature-settings: 'ss02' on, 'ss09' on, 'zero' on;
  display: inline-block;
  color: ${({ color }) => color || colors.content.onBackground};
  ${({ noWrap }) => noWrap && 'white-space: nowrap;'}
  ${({ underline }) => underline && 'text-decoration: underline;'}
  ${({ typography }) => getTypography(typography, 'desktop')}
  ${({ transition }) => transition && `transition: ${transition};`}

  ${({ overflowStyle }) => overflowStyle &&
    `
    max-width: 100%;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ${overflowStyle};
  `}


  @media (max-width: ${Breakpoints.Mobile}) {
    ${({ mobileTypography, typography }) => {
    if (mobileTypography)
        return getTypography(mobileTypography, 'desktop');
    return getTypography(typography, 'mobile');
}};
`;
const Superscript = styled.span `
  font-size: 0.6em;
  vertical-align: super;
  margin: 0;
  display: inline;
  line-height: 1;
`;
const processSuperscript = (children) => {
    if (typeof children === 'string') {
        // Replace registered trademark symbol with superscript
        const processedString = children.replace(/®/g, '<sup>®</sup>');
        // Split the string based on <sup> tags
        const parts = processedString.split(/<sup>|<\/sup>/);
        return (React.createElement(React.Fragment, null, parts.map((part, index) => index % 2 === 0 ? part : React.createElement(Superscript, { key: index }, part))));
    }
    return children;
};
export default function ImpText({ typography = 'body2', children, color, mobileTypography, underline = false, dataTestId = 'text', 
// DEPRECATED
handleRegisteredSymbol = false, handleSuperscript = false, transition, noWrap = false, overflowStyle, ...props }) {
    if (handleRegisteredSymbol) {
        console.warn('handleRegisteredSymbol is deprecated. Use handleSuperscript instead');
    }
    const processedChildren = handleSuperscript
        ? processSuperscript(children)
        : children;
    return (React.createElement(ImpP, { typography: typography, color: color, mobileTypography: mobileTypography, "data-testid": dataTestId, underline: underline, transition: transition, noWrap: noWrap, overflowStyle: overflowStyle, ...props }, processedChildren));
}
//# sourceMappingURL=ImpText.js.map